import { render, staticRenderFns } from "./ClassMarkDataTable.vue?vue&type=template&id=3559fbe6&scoped=true&"
import script from "./ClassMarkDataTable.vue?vue&type=script&lang=js&"
export * from "./ClassMarkDataTable.vue?vue&type=script&lang=js&"
import style0 from "./ClassMarkDataTable.vue?vue&type=style&index=0&id=3559fbe6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3559fbe6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
